// eslint-disable-next-line
/* global Analytics */

const logger = require("../../src/utils/logger");

exports.onRouteUpdate = function({ location }, options) {
  logger.debug("location", location);
};
